import { ACTIVE_ITEM, TOGGLE_SUBMENU } from './constants'

export function activeItem(path, keyToActive) {
    return {
        type: ACTIVE_ITEM,
        data: {
            path,
            keyToActive,
        },
    }
}

export function toggleSubmenu(path, pathToActive) {
    return {
        type: TOGGLE_SUBMENU,
        data: {
            path,
            pathToActive,
        },
    }
}
